import { CONFIG } from '../../core/config';
import { PerformanceStandard } from '../performance-standard';
import { ViewModel } from '../view-model';
import { EquipmentFunctionalFailure } from './equipment-functional-failure';

export class EquipmentFunction implements ViewModel {
  friendlyTypeNameSingular: string = 'Equipment Function';
  apiRoute: string = CONFIG.apiRoutes.equipmentFunctionModel;

  selected: boolean;
  id: string;
  objective: string;
  modelId: string;
  functionalFailures: EquipmentFunctionalFailure[] = [];
  performanceStandard: PerformanceStandard;
  performanceStandardId: string;
  isSaved: boolean = false;

  json() {
    return this;
  }

  loadFromJson(data: any) {
    this.id = data.id;
    this.objective = data.objective;
    this.modelId = data.modelId;
    this.performanceStandard = data.performanceStandard;
    this.performanceStandardId = data.performanceStandardId;
    this.isSaved = data.isSaved;

    if (data.functionalFailures) {
      this.functionalFailures = data.functionalFailures.map((details: EquipmentFunctionalFailure) => {
        const newFailure = new EquipmentFunctionalFailure();
        newFailure.loadFromJson(details);
        return newFailure;
      });
    }

    this.selected = false;
  }
}
